import { promptVars } from '../variables';
import { schemaBasePrompt } from './schemaBasePrompt';
export const schemaModelGeneratePrompt = schemaBasePrompt.human(`Generate ORM-DSL for following application:

# Application specification
${promptVars.specification}
`);
//# sourceMappingURL=schemaModelGeneratePrompt.js.map